import { jsx as _jsx } from "react/jsx-runtime";
import { ModelWithDescription, staticTableCellDecorator } from 'Shared/components';
export const createModelWithDescription = staticTableCellDecorator(({ description, name, nameWithSubscript }) => (_jsx(ModelWithDescription, { description: description, name: name, nameWithSubscript: nameWithSubscript }, void 0)));
